import { Select } from 'antd'
import * as React from 'react'

import { IUtilityService } from '../../services/UtilityService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

interface YearPickerProps {
    clienteId: string
    onAnnoChange: (value: number) => void
}

class YearPickerState {
    Anni: Array<number> = []
    Anno: number
}

export class YearPicker extends React.Component<YearPickerProps, YearPickerState> {

    utilityService: IUtilityService

    constructor(props) {
        super(props)
        this.state = new YearPickerState()
        this.utilityService = container.get(SERVICE_IDENTIFIER.UTILITY_SERVICE)
    }

    componentDidMount() {
        this.fetchData()
    }

    onAnnoChange = (value: number) => {
        this.setState({ Anno: value })
        this.props.onAnnoChange(value)
    }

    fetchData = async () => {
        let resp = await this.utilityService.GetAvailableYears(this.props.clienteId)
        if (resp.IsValid === true) {
            const [lastItem] = resp.Anni.slice(-1)
            this.setState({ Anno: lastItem, Anni: resp.Anni })
            this.props.onAnnoChange(lastItem)
        }
    }

    render() {
        return (
            <Select
                value={this.state.Anno}
                onSelect={value => this.onAnnoChange(value)}
                options={this.state.Anni.map(e => ({ label: e, value: e }))} />
        )
    }
}